import React, { SetStateAction } from "react";
import SearchTable from "./search/SearchTable";
import Badge from "./badge/Badge";
import Button, { Icons } from "./buttons/Button";
import {
  ADVANCED_SEARCH_TRANSLATIONS,
  CREATE_NEW_BTN_LABEL_TRANSLATIONS,
} from "../translations/util";

interface IProps {
  selectedColumn: { id: string; value: string } | null;
  setSelectedColumn: React.Dispatch<
    SetStateAction<{ id: string; value: string } | null>
  >;
  filterColumns: Array<{ id: string; value: string }>;
  onSearch: (searchTerm?: string) => void;
  setShowAdvancedSearch?: React.Dispatch<SetStateAction<boolean>>;
  showCreateButton: boolean;
  onCreateButtonClick?: () => void;
  onBulkUploadButtonClick?: () => void;
  numberOfAdvancedSearchFilters?: number;
  clearAdvancedSearchFilters?: () => void;
  showAdvancdSearch?: boolean;
  showSearch?: boolean;
  showBulkUploadButton?: boolean;
  isDFSIdataExists?: boolean;
  showIKICertificateDownloadButton?: boolean;
  onDownloadButtonClick?: () => void;
}

const DataTableControls = ({
  selectedColumn,
  setSelectedColumn,
  filterColumns,
  onSearch,
  setShowAdvancedSearch,
  showCreateButton,
  onCreateButtonClick,
  onBulkUploadButtonClick,
  numberOfAdvancedSearchFilters,
  clearAdvancedSearchFilters,
  showAdvancdSearch = true,
  showSearch = true,
  showBulkUploadButton,
  isDFSIdataExists = false,
  showIKICertificateDownloadButton = false,
  onDownloadButtonClick,
}: IProps) => {
  return (
    <div className="flex justify-between bg-white mb-6">
      <div className="left-section">
        {showSearch ? (
          <SearchTable
            selectedColumn={selectedColumn}
            setSelectedColumn={setSelectedColumn}
            filterColumnList={filterColumns}
            searchFunction={onSearch}
          />
        ) : null}
      </div>
      <div className="right-section">
        <div className="mr-2">
          {showAdvancdSearch ? (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {!numberOfAdvancedSearchFilters ? (
                <Button
                  kind="tertiary"
                  className="w-full search-set"
                  label={ADVANCED_SEARCH_TRANSLATIONS.label}
                  icon={Icons.Search}
                  onClick={() => {
                    if (setShowAdvancedSearch) setShowAdvancedSearch(true);
                  }}
                  dataCy="advanceSearch-"
                />
              ) : (
                <div className="w-full cds--btn cds--btn--tertiary search-reset">
                  <Badge badgeCounter={`${numberOfAdvancedSearchFilters}`} />
                  {ADVANCED_SEARCH_TRANSLATIONS.label}
                  <Button
                    onClick={clearAdvancedSearchFilters}
                    kind="ghost"
                    className="btn-clear"
                    icon={Icons.Close}
                    dataCy="clearAdvanceSearchFilter-"
                  />
                </div>
              )}
            </>
          ) : null}
        </div>

        {showCreateButton ? (
          <div className="mr-2">
            <Button
              kind="primary"
              className="w-full"
              label={CREATE_NEW_BTN_LABEL_TRANSLATIONS}
              dataCy="createNew-"
              icon={Icons.Add}
              onClick={onCreateButtonClick || (() => null)}
              disabled={isDFSIdataExists}
            />
          </div>
        ) : null}

        {showBulkUploadButton ? (
          <div className="mr-2 bulk-upload-iconbutton">
            <Button
              kind="tertiary"
              className="w-full bulk-upload-button"
              hasIconOnly
              dataCy="bulkUpload-"
              icon={Icons.CloudUpload}
              iconDescription="Bulk Upload"
              onClick={onBulkUploadButtonClick || (() => null)}
              disabled={isDFSIdataExists}
            />
          </div>
        ) : null}

        {showIKICertificateDownloadButton ? (
          <div className="mr-2 bulk-upload-iconbutton">
            <Button
              kind="tertiary"
              className="w-full bulk-upload-button"
              hasIconOnly
              dataCy="ikiCertificateDownload-"
              icon={Icons.Key}
              iconDescription="Download IWF Certificate"
              onClick={onDownloadButtonClick || (() => null)}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DataTableControls;
